const getBaseUrl = () => {
    return process.env.REACT_APP_API_BASE_URL?.replace('/api', '') || 'http://127.0.0.1:8001';
};

export const getImageUrl = (path: string | null | undefined) => {
    if (!path) {
        console.warn('getImageUrl: No path provided, using placeholder');
        return 'https://placehold.co/400';
    }
    if (path.startsWith('http') || path.startsWith('data:')) {
        return path;
    }

    const baseUrl = getBaseUrl();
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // If the path already includes storage/, don't prepend it again
    if (cleanPath.startsWith('storage/')) {
        return `${baseUrl}/${cleanPath}`;
    }

    return `${baseUrl}/storage/${cleanPath}`;
};

/**
 * Fixes relative image URLs in HTML content (e.g. from rich text editors)
 * by prepending the base URL.
 */
export const fixHtmlContent = (html: string | undefined | null) => {
    if (!html) return '';
    const baseUrl = getBaseUrl();

    // Match src="URL" or src='URL'
    return html.replace(/src=(["'])([^"']+)\1/g, (match, quote, url) => {
        // If it's already an absolute URL or data URI, leave it as is
        if (url.startsWith('http') || url.startsWith('data:') || url.startsWith('//')) {
            return match;
        }

        // Clean path and ensure it starts with /storage/
        let cleanPath = url.startsWith('/') ? url.substring(1) : url;

        // If path doesn't already start with storage/, prepend it
        // This covers cases like "/images/..." becoming "DOMAIN/storage/images/..."
        if (!cleanPath.startsWith('storage/')) {
            cleanPath = `storage/${cleanPath}`;
        }

        return `src=${quote}${baseUrl}/${cleanPath}${quote}`;
    });
};
